import cn from 'classnames';
import AnimateHeight from 'react-animate-height';
import ErrorMessage from 'components/ErrorMessage/index.js';
import './index.scss';

const Input = ({
    label,
    type,
    name,
    errors,
    className,
    maxLength,
    inputClassName = '',
    multiple,
    options,
    ...rest
}) => {
    const hasError = !!errors?.[name]?.length;
    const hasOptions = !!options?.length;
    const idDatalist = hasOptions ? `${name || 'input'}-datalist` : undefined;

    return (
        <label className={cn('form-label', className)}>
            <span className='form-label-text'>{label}</span>
            <div className='form-field'>
                <input
                    type={type || 'text'}
                    name={name}
                    maxLength={maxLength || 100}
                    className={`form-field-input ${inputClassName} ${hasError ? 'invalid' : ''}`}
                    list={idDatalist}
                    {...rest}
                />
                {hasOptions && (
                    <datalist id={idDatalist}>
                        {options.map(option => <option key={option} value={option}>{option}</option>)}
                    </datalist>
                )}
            </div>
            <AnimateHeight animateOpacity duration={200} height={hasError ? 'auto' : 0}>
                <ErrorMessage className={`form-error ${hasError ? 'has-error' : ''}`}>
                    {errors?.[name] || ''}
                </ErrorMessage>
            </AnimateHeight>
        </label>
    );
};

export default Input;
